import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

// Silence diagnostic console output in production builds so user data,
// session info, and API payloads are not exposed via DevTools.
// console.error is intentionally preserved so real errors still surface.
// To re-enable in prod for debugging, set localStorage.debug = "1" and reload.
if (
  process.env.NODE_ENV === 'production' &&
  typeof window !== 'undefined' &&
  window.localStorage?.getItem('debug') !== '1'
) {
  const noop = () => {};
  ['log', 'info', 'debug', 'warn', 'trace', 'dir', 'table', 'group', 'groupCollapsed', 'groupEnd']
    .forEach((m) => {
      if (typeof console[m] === 'function') console[m] = noop;
    });
}

// require('dotenv').config();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
